module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightrain@2-3512dc5ed1df886eb12bba6c618bca35.png";